import React, {useState} from "react";
import {useTranslation} from "react-i18next";
import {useCustomerContext} from "../../customer/CustomerContextProvider/CustomerContextProvider";
import {Button, ButtonStyles} from "../form/Button/Button";
import {getShopId} from "../getShopId";
import Modal from "./Modal";

interface IForgotPasswordModalProps {
  closeFunction: () => void;
  isVisible: boolean;
}

const ForgotPasswordModal: React.FC<IForgotPasswordModalProps> = (props) => {
  const {customer} = useCustomerContext();
  const {t} = useTranslation("checkout");
  const contactPhone = contactPhoneNumbers[getShopId()];

  const EmailSentText: React.FC = () => (
    <React.Fragment>
      <p className="content" style={{margin: "16px 0"}}>
        {t("In Ihrem Postfach finden Sie nun eine E-Mail. ...")}{" "}
        <a style={{cursor: "pointer", color: "#1BA1E2"}} href={`tel:${contactPhone}`}>
          {contactPhone}
        </a>
      </p>
      <div className="center">
        <Button styles={[ButtonStyles.big]} action={props.closeFunction}>
          {t("Okay")}
        </Button>
      </div>
    </React.Fragment>
  );

  const EnterEmail: React.FC = () => {
    const [email, setEmail] = useState<string>();
    const [{emailSent, error}, setEmailState] = useState<{emailSent: boolean; error: boolean}>({
      emailSent: false,
      error: false,
    });
    const [validEmail, setValidEmail] = useState<boolean>(true);

    const sendEmail = async (evt: React.FormEvent) => {
      evt.preventDefault();
      try {
        if (email && validateEmail(email)) {
          setValidEmail(true);
          await customer.requestPassword(email);
          setEmailState((prevState) => ({...prevState, emailSent: true}));
        } else {
          setValidEmail(false);
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        setEmailState((prevState) => ({...prevState, error: true}));
      }
    };

    if (emailSent) {
      return <EmailSentText />;
    }

    return (
      <React.Fragment>
        <p className="content">{t("Sie haben schon einmal bei uns eingekauft, ...")}</p>
        {error && (
          <p style={{color: "red"}}>
            {t("Bei der Übertragung ist ein Fehler aufgetreten. Bitte versuchen Sie es noch einmal.")}
          </p>
        )}
        {!validEmail && <span style={{color: "red"}}>{t("Die eingegebene E-Mail-Adresse ist nicht gültig.")}</span>}
        <form style={{margin: "16px 0"}} onSubmit={(evt: React.FormEvent) => sendEmail(evt)}>
          <input
            style={{marginBottom: "16px", display: "block"}}
            type="email"
            placeholder={t("Ihre E-Mail-Adresse *")}
            onChange={(e) => setEmail(e.target.value.trim())}
          />
          <Button styles={[ButtonStyles.big]}>{t("Passwort anfordern")}</Button>
        </form>
      </React.Fragment>
    );
  };

  return (
    <Modal isVisible={props.isVisible} closeFunction={props.closeFunction}>
      <h2>{t("Passwort zurücksetzen")}</h2>
      <EnterEmail />
    </Modal>
  );
};

export default ForgotPasswordModal;

export const validateEmail = (email: string): boolean => {
  const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;

  return expression.test(String(email).toLowerCase());
};
const contactPhoneNumbers: {[key: number]: string} = {
  100001: "+49-511-93688676",
  100009: "+4312056367189",
  100017: "+41432157892",
  100027: "+41 43 2157892",
  100005: "+18184477206",
  100020: "+442038800027",
  100008: "+33185642360",
  100022: "+4532725247",
  100029: "+31207081554",
};
